export default __webpack_public_path__ + "static/media/teamwork-upper-l.72e089a3.png";